<!-- V2 Wallet -->
 <div #pageHeader>
   <fgb-page-header [pageTitle]="'wallet.page.title'" [showBalance]="false" [showQr]="true" [backButtonLink]="'/'"></fgb-page-header>
 </div>
<div #walletContainer class="wallet-container">
  <ng-container *ifScreenSize="screenType.Mobile">
    <div class="grab-point"><span class="minimize-icon"> </span></div>
  </ng-container>
  <ng-container *ngIf="walletItems$ | async as walletItems">
    <div class="wallet-redeem-carousel pt-4">
      <div class="container">
        <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
      </div>
    </div>
  </ng-container>

  <div class="container mt-50">
    <div class="history-container">
      <div class="history">
        <h5 class="title font-size-18 fw-bold">{{ 'redemption.history.title' | translate }}</h5>
        <p class="description font-size-14 mb-0">{{ 'redemption.history.description' | translate }}</p>
      </div>
      <a class="font-size-14 claimed-text fw-bold text-center" [routerLink]="['/rewards/claimed']">
        {{ 'rewards.wallet.view.claimed' | translate }}
      </a>
    </div>
  </div>
</div>
